import React, { Component }       from 'react'
import classnames                 from 'classnames'
import {
  Props,
  State,
  TOGGLE_STATUS,
}                                 from './types'
import                            './styles.scss'

class ToggleSwitch extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isActive: props.default
    }

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    const { isActive } = this.state

    this.setState({ isActive: !isActive })
  }

  componentWillReceiveProps(nextProps: Props) {
    const { default: nextDefault } = nextProps

    if (this.props.default !== nextDefault) {
      this.setState({
        isActive: nextDefault
      })
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { onHandleClick } = this.props
    const { isActive } = this.state
    const { isActive: prevIsActive } = prevState

    if (isActive !== prevIsActive) {
      onHandleClick(isActive)
    }
  }

  render() {
    const {
      isActive,
    } = this.state
    const { disabled } = this.props

    if (!disabled) {
      return (
        <React.Fragment>
          <div
            onClick={this.handleClick}
            className={classnames('toggleSwitchField', isActive ? 'toggleSwitchField__isActive' : null, disabled ? 'toggleSwitchField__disabled' : null)}
          >
            <div className={'toggleSwitchField__circle'} />
          </div>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <div
          className="toggleSwitchField"
          style={{
            background: 'none',
            width: 'auto',
            height: 'auto',
          }}
        >
          { isActive ? TOGGLE_STATUS.ENABLED : TOGGLE_STATUS.DISABLED }
        </div>
      </React.Fragment>
    )
  }
}

export default ToggleSwitch
